import { LogOut } from "lucide-react";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";
import { SidebarMenuButton } from "../ui/sidebar";
import { useAuth0Login } from "~/hooks/useAuth0Login";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export const LogoutModal = ({ open, onOpenChange }: Props) => {
  const { logout } = useAuth0Login();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <SidebarMenuButton tooltip="Logout" className="cursor-pointer" onClick={() => onOpenChange(true)}>
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </SidebarMenuButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Logout</DialogTitle>
          <DialogDescription>
            Are you sure you want to logout? You will be redirected to the
            ProudlyHuman™ website.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant={"outline"} onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={() => logout()}>Logout</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
